import { PROVISIONAL_TOURNAMENT_LIST_ACTION } from 'core/constants/Actions'
import { Action } from 'core/models/ActionTypes'
import { Tournament } from 'core/models/Tournament'

const initialState: { tournaments: Tournament[], count: number, currentPage: number, isLoading: boolean } = {
  tournaments: [],
  isLoading: false,
  count: 0,
  currentPage: 0
}

interface ActionType extends Action {
  payload: {
    tournaments: Tournament[];
    count: number;
    currentPage: number;
  }
}

export default function provisionalTournamentListReducer(state = initialState, action: ActionType) {

  switch (action.type) {
    case PROVISIONAL_TOURNAMENT_LIST_ACTION.REQUEST:
      return { ...state, isLoading: true }

    case PROVISIONAL_TOURNAMENT_LIST_ACTION.SUCCESS:
      const { tournaments, count, currentPage } = action.payload;
      return { ...state, tournaments, count, currentPage, isLoading: false }

    case PROVISIONAL_TOURNAMENT_LIST_ACTION.FAILURE:
      return { ...state, ...initialState }

    default:
      return state
  }
}